export const selectUserSlice = (state) => state.user.currentUser;